import { HttpClient } from '@wix/http-client';
import { getRandomTemplateImageBySectionAndFlow } from './fetchDataUtils';
import {
  TEXT_ON_IMAGE_FLOWS,
  TextOnImageGetPhotoSceneParams,
  TextOnImageResponse,
  TextOnImageSkyPhotoParams,
} from '../types';
import {
  AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
  PromptHubAcceptedUrls,
} from '../../chatController/sgChat/constants';
import {
  PHOTO_SCENES_PROMPT_IDS,
  FLUX_PRO_DEPTH_SKY_IMAGE_GENERATION_PROMPT_ID,
} from './consts';
import { reportTextOnImageError } from './utils';
import { SG_FEATURE_NAME } from '../../consts';

const CONTROL_IMAGE_URL =
  'https://static.wixstatic.com/media/47a484_8b4f28160cc94f6f8f3f8e2427646962~mv2.jpg';

export const getSkyFlowImage = async (
  httpClient: HttpClient,
  sectionName: string,
  params: TextOnImageGetPhotoSceneParams,
): Promise<TextOnImageResponse | undefined> => {
  const { brightness, sectionId } = params;
  const photoScene = await getTextOnImagePhotoSceneSkyFlow(httpClient, {
    ...params,
    brightness,
  });

  if (!photoScene) return;

  const templateImageFromCMS = await getRandomTemplateImageBySectionAndFlow(
    sectionName,
    TEXT_ON_IMAGE_FLOWS.SKY,
    sectionId,
  );

  const controlImageUrl = templateImageFromCMS?.url || CONTROL_IMAGE_URL;
  const imageUrl = await getTextOnImageSkyPhotoPromptHub(httpClient, {
    sky_item: photoScene,
    controlImageUrl,
    brightness,
  });

  return { imageUrl, photoScene, controlImageUrl };
};

export const getTextOnImagePhotoSceneSkyFlow = async (
  httpClient: HttpClient,
  params: TextOnImageGetPhotoSceneParams,
): Promise<string> => {
  try {
    const { data } = await httpClient.post(
      PromptHubAcceptedUrls.AI_GATEWAY_URL,
      {
        appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
        promptId: PHOTO_SCENES_PROMPT_IDS[TEXT_ON_IMAGE_FLOWS.SKY],
        params,
        userRequestInfo: {
          featureName: SG_FEATURE_NAME,
        },
      },
    );
    const { sky_item1 } = JSON.parse(data.response.generatedTexts[0]);
    return sky_item1;
  } catch (error: any) {
    const errorResponse = error.response?.data;
    reportTextOnImageError(
      `Failed to get text on image photo scene: ${errorResponse}`,
    );
    return 'The clear sky occupies two-thirds of the frame, entirely cloudless and in a vivid, light blue hue.';
  }
};

export const getTextOnImageSkyPhotoPromptHub = async (
  httpClient: HttpClient,
  params: TextOnImageSkyPhotoParams,
): Promise<string | undefined> => {
  try {
    const { data } = await httpClient.post(
      PromptHubAcceptedUrls.AI_GATEWAY_GET_BLACK_FOREST_AI_IMAGE,
      {
        appDefId: AI_GATEWAY_APP_DEF_FOR_GET_PROMPTS,
        promptIdToFetch: FLUX_PRO_DEPTH_SKY_IMAGE_GENERATION_PROMPT_ID,
        params,
      },
    );

    return data?.response?.url;
  } catch (error: any) {
    const errorResponse = error.response?.data;
    reportTextOnImageError(`Failed to get sky flow image: ${errorResponse}`);
  }
};
